import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../../../core/authentication/authentication.service';
import { SweetAlertService } from '../../../../shared/services/sweet-alert.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpStatusCode } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-verify-password-modal',
  templateUrl: './verify-password-modal.component.html',
  styleUrls: ['./verify-password-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VerifyPasswordModalComponent {
  loading = false;
  isSSO: boolean;
  form: FormGroup;
  modalRef: NgbModalRef;

  @Output() verified = new EventEmitter<void>();
  @ViewChild('verifyModal') verifyModal: ElementRef;

  constructor(
    private modal: NgbModal,
    private authenticationService: AuthenticationService,
    private swal: SweetAlertService,
    private fb: FormBuilder,
    private router: Router
  ) {}

  onConfirm(): void {
    this.loading = true;

    this.authenticationService
      .verifyPassword(this.form.get('password').value)
      .subscribe(
        () => {
          this.loading = false;
          this.verified.emit();
          this.close();
        },
        (error) => {
          this.loading = false;
          this.swal.toast({
            type: 'error',
            error: error.error,
          });

          if (error.status === HttpStatusCode.Forbidden) {
            this.close();
            this.authenticationService.logout();
            location.reload();
          }
        }
      );
  }

  reAuthenticate(): void {
    this.authenticationService.logout();
    window.location.href = `${environment.baseUrl}/backend/api/saml/login/?return_to=${this.router.url}`;
  }

  open(): void {
    this.form = this.fb.group({
      password: ['', Validators.required],
    });
    this.modalRef = this.modal.open(this.verifyModal, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'custom-ngb-modal-window',
      backdropClass: 'custom-ngb-modal-backdrop',
    });
    this.isSSO = this.authenticationService.isSSO;
  }

  close(): void {
    if (!this.modalRef) {
      return;
    }
    this.modalRef.close();
  }
}
